
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_1ykar_jt3h6_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_jt3h6_1",
  "root": "awsui_root_1ykar_jt3h6_124",
  "calendar-inner": "awsui_calendar-inner_1ykar_jt3h6_165",
  "calendar-header": "awsui_calendar-header_1ykar_jt3h6_168",
  "calendar-header-month": "awsui_calendar-header-month_1ykar_jt3h6_173",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_1ykar_jt3h6_180",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_1ykar_jt3h6_183",
  "calendar-grid": "awsui_calendar-grid_1ykar_jt3h6_186",
  "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_jt3h6_190",
  "calendar-day-header": "awsui_calendar-day-header_1ykar_jt3h6_196",
  "calendar-day": "awsui_calendar-day_1ykar_jt3h6_196",
  "calendar-day-enabled": "awsui_calendar-day-enabled_1ykar_jt3h6_213",
  "calendar-day-current-month": "awsui_calendar-day-current-month_1ykar_jt3h6_220",
  "calendar-day-selected": "awsui_calendar-day-selected_1ykar_jt3h6_227",
  "calendar-day-today": "awsui_calendar-day-today_1ykar_jt3h6_230",
  "day-inner": "awsui_day-inner_1ykar_jt3h6_245",
  "calendar-week": "awsui_calendar-week_1ykar_jt3h6_310"
};
  